/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function e(e) {
  return !!e && e.prototype?.declaredClass && 0 === e.prototype.declaredClass.indexOf("esri.core.Collection");
}
export { e as isCollection };